import React, { useEffect, useState } from 'react';
import { Link, Center, Button, Input, Text } from '@chakra-ui/react';
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from 'react-icons/md';

const TablePagination = ({
  range,
  setPage,
  page,
  slice,
}: {
  range: any;
  setPage: any;
  page: any;
  slice: any;
}) => {
  const [inputValue, setInputValue] = useState(page);

  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
  }, [slice, page, setPage]);

  useEffect(() => {
    setInputValue(page);
  }, [page]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleInputBlur = () => {
    const newPage = parseInt(inputValue, 10);
    if (newPage >= 1 && newPage <= range.length) {
      setPage(newPage);
    } else {
      setInputValue(page); // Reset to current page if input is invalid
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleInputBlur();
    }
  };

  return (
    <>
      <Center>
        <Button
          bg="white"
          size="sx"
          onClick={() => setPage(1)}
          leftIcon={<MdKeyboardDoubleArrowLeft />}
          isDisabled={page === 1}
        />
        <Button
          bg="white"
          size="sx"
          onClick={() => setPage(page - 1)}
          leftIcon={<MdKeyboardArrowLeft />}
          isDisabled={page === 1}
        />
        <Input
          height="25px"
          width="100px"
          textAlign="center"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onKeyDown={handleKeyDown}
        />
        <Text>/ {range.length}</Text>
        <Button
          bg="white"
          size="sx"
          onClick={() => setPage(page + 1)}
          rightIcon={<MdKeyboardArrowRight />}
          isDisabled={page === range.length}
        />
        <Button
          bg="white"
          size="sx"
          onClick={() => setPage(range.length)}
          rightIcon={<MdKeyboardDoubleArrowRight />}
          isDisabled={page === range.length}
        />
      </Center>
    </>
  );
};

export default TablePagination;
